import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { IconComponent } from '@libs/components/icons';
import { ComponentsIconsStyle, IconName } from '@libs/shared/models';

@Component({
  selector: 'ui-modal-icon-title',
  imports: [
    IconComponent,
  ],
  templateUrl: './modal-icon-title.component.html',
  styleUrl: './modal-icon-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalIconTitleComponent {
  public icon: InputSignal<IconName> = input.required();
  public iconStyle: InputSignal<ComponentsIconsStyle> = input<ComponentsIconsStyle>('solid');
  public title: InputSignal<string> = input.required();
}
